export const PATHS = {
    ROOT: 'tasks',
    TASKS: 'tasks',
    INVENTORY: 'inventory',
    ORDERS: 'orders',
}

export const STATUSES = {
    PLANNED: 'Planned',
    INPROGRESS: 'In Progress',
    DONE: 'Done',
    REJECTED: 'Rejected',
}